
import { TableCell, TableRow, Tooltip, Chip, Button, } from '@mui/material';
import { rateColorMeasures } from '../../../../helpers/common';
import { panelsActive, panelsRemoveActive } from '../../../../reducers/panels/panelsReducer';
import { nodesActive, nodesRemoveActive } from '../../../../reducers/nodes/nodesReducer';
import { gatewaysActive, gatewaysRemoveActive } from '../../../../reducers/gateways/gatewaysReducers';
import { useDispatch } from 'react-redux';
import { startContractsActive } from '../../../../reducers/contracts/contractsActions';
import { CommunicationFailsTooltipChips } from './CommunicationFailsTooltipChips/CommunicationFailsTooltipChips';



export const ContractRow = ({ contract, activeContractId }) => {

  const dispatch = useDispatch();

  const handleClick = (id) => {
    dispatch(startContractsActive(id))
  }

  const panelCount = contract.device_counts[0];
  const nodeCount = contract.device_counts[1];
  const gatewayCount = contract.device_counts[2];
  const failureWindowInHours = contract.failure_window_in_hours;
  const failureWindowInHoursPanels = contract.failure_window_in_hours_panels;



  const filteredAlertsCm = contract.alerts_cm.filter(
    (id) => !contract.fails_cm?.fails24.includes(id)
  );
  const filteredAlertsNodes = contract.alert_nodes.filter(
    (id) => !contract.fails_nodes?.fails24.includes(id)
  );


  const colorPanelsFail24 = rateColorMeasures(contract.fails_cm?.fails24?.length || 0, panelCount, undefined, true, contract.fails_cm?.fails48?.length || 0);
  const colorPanelsFail48 = rateColorMeasures(contract.fails_cm?.fails48?.length || 0, panelCount, undefined, true, contract.fails_cm?.fails72?.length || 0);
  const colorPanelsFail72 = rateColorMeasures(contract.fails_cm?.fails72?.length || 0, panelCount, undefined, true, contract.fails_cm?.fails96?.length || 0);
  const colorPanelsFail96 = rateColorMeasures(contract.fails_cm?.fails96?.length || 0, panelCount, undefined, true, contract.fails_cm?.fails120?.length || 0);
  //const colorPanelsFail120 = rateColorMeasures(contract.fails_cm?.fails120?.length || 0, panelCount, undefined, true);
  const colorPanelsAlarm = rateColorMeasures(filteredAlertsCm?.length || 0, panelCount);

  const colorNodesFail24 = rateColorMeasures(contract.fails_nodes?.fails24?.length || 0, nodeCount, undefined, true, contract.fails_nodes?.fails48?.length || 0);
  const colorNodesFail48 = rateColorMeasures(contract.fails_nodes?.fails48?.length || 0, nodeCount, undefined, true, contract.fails_nodes?.fails72?.length || 0);
  const colorNodesFail72 = rateColorMeasures(contract.fails_nodes?.fails72?.length || 0, nodeCount, undefined, true, contract.fails_nodes?.fails96?.length || 0);
  const colorNodesFail96 = rateColorMeasures(contract.fails_nodes?.fails96?.length || 0, nodeCount, undefined, true, contract.fails_nodes?.fails120?.length || 0);
  //const colorNodesFail120 = rateColorMeasures(contract.fails_nodes?.fails120?.length || 0, nodeCount, undefined, true);
  const colorNodesAlarm = rateColorMeasures(filteredAlertsNodes?.length || 0, nodeCount);

  const colorGatewaysFail24 = rateColorMeasures(contract.fails_gateways?.fails24?.length || 0, gatewayCount, undefined, true, contract.fails_gateways?.fails48?.length || 0);
  const colorGatewaysFail48 = rateColorMeasures(contract.fails_gateways?.fails48?.length || 0, gatewayCount, undefined, true, contract.fails_gateways?.fails72?.length || 0);
  const colorGatewaysFail72 = rateColorMeasures(contract.fails_gateways?.fails72?.length || 0, gatewayCount, undefined, true, contract.fails_gateways?.fails96?.length || 0);
  const colorGatewaysFail96 = rateColorMeasures(contract.fails_gateways?.fails96?.length || 0, gatewayCount, undefined, true, contract.fails_gateways?.fails120?.length || 0);
  //const colorGatewaysFail120 = rateColorMeasures(contract.fails_gateways?.fails120?.length || 0, gatewayCount, undefined, true);



  const handleActivatePanels = (Ids) => {
    if (Ids.length > 0 && activeContractId === contract.id) {
      dispatch(panelsRemoveActive());
      dispatch(panelsActive(Ids.map(id => ({ id }))));
    }
  };

  const handleActivateNodes = (Ids) => {
    if (Ids.length > 0 && activeContractId === contract.id) {
      dispatch(nodesRemoveActive());
      dispatch(nodesActive(Ids.map(id => ({ id }))));
    }
  };

  const handleActivateGateways = (Ids) => {
    if (Ids.length > 0 && activeContractId === contract.id) {
      dispatch(gatewaysRemoveActive());
      dispatch(gatewaysActive(Ids.map(id => ({ id }))));
    }
  };


  return (
    <TableRow selected={activeContractId === contract.id}>
      <TableCell style={{ borderRight: '1px solid black' }}>
        <Button
          onClick={() => { return handleClick(contract.id) }}
          variant="outlined"
          disabled={activeContractId === contract.id}
          style={{
            fontWeight: 'bold',
            color: activeContractId === contract.id ? 'white' : 'black',
            backgroundColor: activeContractId === contract.id ? '#f39c12' : 'transparent',
            borderColor: activeContractId === contract.id ? '#f39c12' : 'rgba(0, 0, 0, 0.23)',
          }}
        >
          {contract.name}
        </Button>


      </TableCell>

      <TableCell>
        {panelCount > 0 ? (
          <>
            <CommunicationFailsTooltipChips
              contractFails={contract.fails_cm} handleActivate={handleActivatePanels} deviceCount={panelCount}
              colorFail120={{ value: contract.fails_cm?.fails120?.length || 0, percentage: 0, color: '#f2f4f4' }} colorFail96={colorPanelsFail96} colorFail72={colorPanelsFail72}
              colorFail48={colorPanelsFail48} colorFail24={colorPanelsFail24}
            />
            <Tooltip title={'Ventana de fallos de comunicacion'}>

              <Chip label={`${failureWindowInHours}h`} size='small' style={{ marginLeft: '10px' }}></Chip>
            </Tooltip>
          </>
        ) : (
          <span style={{ fontWeight: 'bold', marginLeft: '10px' }}>-</span>
        )}
      </TableCell>

      <TableCell>
        {nodeCount > 0 ? (
          <>
            <CommunicationFailsTooltipChips
              contractFails={contract.fails_nodes} handleActivate={handleActivateNodes} deviceCount={nodeCount}
              colorFail120={{ value: contract.fails_nodes?.fails120?.length || 0, percentage: 0, color: '#f2f4f4' }} colorFail96={colorNodesFail96} colorFail72={colorNodesFail72}
              colorFail48={colorNodesFail48} colorFail24={colorNodesFail24}
            />
            <Tooltip title={'Ventana de fallos de comunicacion'}>

              <Chip label={`${failureWindowInHoursPanels}h`} size='small' style={{ marginLeft: '10px' }}></Chip>
            </Tooltip>

          </>
        ) : (
          <span style={{ fontWeight: 'bold', marginLeft: '10px' }}>-</span>
        )}
      </TableCell>

      <TableCell style={{ borderRight: '1px solid black' }}>
        {gatewayCount > 0 ? (
          <>
            <CommunicationFailsTooltipChips
              contractFails={contract.fails_gateways} handleActivate={handleActivateGateways} deviceCount={gatewayCount}
              colorFail120={{ value: contract.fails_gateways?.fails120?.length || 0, percentage: 0, color: '#f2f4f4' }} colorFail96={colorGatewaysFail96} colorFail72={colorGatewaysFail72}
              colorFail48={colorGatewaysFail48} colorFail24={colorGatewaysFail24}
            />
          </>
        ) : (
          <span style={{ fontWeight: 'bold', marginLeft: '10px' }}>-</span>
        )}
      </TableCell>


      <TableCell>
        <Tooltip title={`${colorPanelsAlarm.percentage}%`}>
          <Chip size='small'
            label={`${colorPanelsAlarm.value}`}
            style={{ backgroundColor: colorPanelsAlarm.color }}
            onClick={() => handleActivatePanels(filteredAlertsCm)}
          />
        </Tooltip>
      </TableCell>

      <TableCell>
        <Tooltip title={`${colorNodesAlarm.percentage}%`}>
          <Chip size='small'
            label={`${colorNodesAlarm.value}`}
            style={{ backgroundColor: colorNodesAlarm.color }}
            onClick={() => handleActivateNodes(filteredAlertsNodes)}
          />
        </Tooltip>
      </TableCell>

    </TableRow >
  );
};



